import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import styled from 'styled-components';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import es from 'date-fns/locale/es';
import nl from 'date-fns/locale/nl';
import no from 'date-fns/locale/nb';
import pt from 'date-fns/locale/pt';
import sv from 'date-fns/locale/sv';
import zhCN from 'date-fns/locale/zh-CN';
import zhTW from 'date-fns/locale/zh-TW';
import ko from 'date-fns/locale/ko';
import jaJP from 'date-fns/locale/ja';
import da from 'date-fns/locale/da';
import fi from 'date-fns/locale/fi';
import hu from 'date-fns/locale/hu';
import it from 'date-fns/locale/it';
import pl from 'date-fns/locale/pl';
import ro from 'date-fns/locale/ro';
import th from 'date-fns/locale/th';
import useLocale from 'hooks/useLocale';
import { useFormFieldContext } from 'components/FormField';
import { textInputProps, textInputStyle } from 'components/TextInput';
import Box from 'components/Box';
import StyleWrapper from './StyleWrapper';
setDefaultLocale('en-GB');
registerLocale('en-GB', enGB);
registerLocale('en-US', enUS);
registerLocale('de-DE', de);
registerLocale('de-DE-Sie', de);
registerLocale('fr-FR', fr);
registerLocale('es-ES', es);
registerLocale('nl-NL', nl);
registerLocale('no-NO', no);
registerLocale('pt-PT', pt);
registerLocale('sv-SE', sv);
registerLocale('zh-CN', zhCN);
registerLocale('zh-TW', zhTW);
registerLocale('ja-JP', jaJP);
registerLocale('ko-KR', ko);
registerLocale('da-DK', da);
registerLocale('fi-FI', fi);
registerLocale('hu-HU', hu);
registerLocale('it-IT', it);
registerLocale('pl-PL', pl);
registerLocale('ro-RO', ro);
registerLocale('th-TH', th);
var StyledDatePicker = styled(ReactDatePicker).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !textInputProps.includes(prop);
  }
}).withConfig({
  displayName: "DatePicker__StyledDatePicker",
  componentId: "sc-ire5tk-0"
})(["", ""], textInputStyle);
function DatePicker(props) {
  var _useLocale = useLocale(),
    locale = _useLocale.locale;
  var _useFormFieldContext = useFormFieldContext({
      id: props.id,
      required: props.required,
      descriptionIds: props['aria-describedby']
    }),
    id = _useFormFieldContext.id,
    required = _useFormFieldContext.required,
    descriptionIds = _useFormFieldContext.descriptionIds;
  return /*#__PURE__*/React.createElement(StyleWrapper, null, /*#__PURE__*/React.createElement(Box, {
    width: props.width || 125
  }, /*#__PURE__*/React.createElement(StyledDatePicker, _extends({}, props, {
    id: id,
    required: required,
    "aria-describedby": descriptionIds,
    locale: locale
  }))));
}
export default DatePicker;